var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Dashboard"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    clipPath: "url(#clip-Dashboard)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_171",
    "data-name": "Pfad 171",
    d: "M718.317,1258.291H689.163a3.128,3.128,0,0,0-3.125,3.125v29.154a3.128,3.128,0,0,0,3.125,3.125h29.154a3.129,3.129,0,0,0,3.125-3.125v-29.154a3.129,3.129,0,0,0-3.125-3.125m1.042,3.125v13.535H704.781v-14.577h13.536a1.044,1.044,0,0,1,1.042,1.042m-31.238,29.154v-29.154a1.044,1.044,0,0,1,1.042-1.042H702.7v31.238H689.163a1.044,1.044,0,0,1-1.042-1.042m30.2,1.042H704.781v-14.579h14.578v13.536a1.044,1.044,0,0,1-1.042,1.042",
    transform: "translate(-673.537 -1245.74)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/Dashboard.9e7131216b0499277eb28e4826a00f73.svg";
export { ForwardRef as ReactComponent };